export { default as useContract } from './useContract';
